export default class JobLocationSummaryDto {
    brandName = '';
    cityTown = '';
    postZipCode = '';
}
